import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useLocation } from 'react-router'
import { useRole, useGymId } from './role'
import { useStaffPermissions, type StaffPermissions } from './useStaffPermissions'

interface RequirePermissionProps {
  /** One permission, or several of which any one lets the staff member in. */
  staffKey: keyof StaffPermissions | (keyof StaffPermissions)[]
  children: React.ReactNode
}

export function RequirePermission({ staffKey, children }: RequirePermissionProps) {
  const { isAuthenticated, isLoading } = useAuth0()
  const role = useRole()
  const gymId = useGymId()
  const staffPermissions = useStaffPermissions()
  const location = useLocation()

  if (isLoading) return null
  if (!isAuthenticated)
    return <Navigate to="/login" state={{ returnTo: location.pathname }} replace />
  if (role === 'gym_owner') return <>{children}</>
  if (role !== 'gym_staff') return <Navigate to="/unauthorized" replace />
  if (!gymId) return <Navigate to="/unauthorized" replace />

  if (staffPermissions === null) return null
  const keys = Array.isArray(staffKey) ? staffKey : [staffKey]
  if (!keys.some((key) => staffPermissions[key] === true)) return <Navigate to="/" replace />

  return <>{children}</>
}
